import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.dokument-aktivieren';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenDokumentAktivierenEffects {

    DokumentAktivieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DOKUMENT_AKTIVIEREN),
        mergeMap((x: ac.PostDokumentAktivierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDokumentAktivieren(x.dokumentAktivierenRequest).pipe(
                map((result: any) => {
                    return new ac.PostDokumentAktivierenErfolgreichAction(result, x.dokumentAktivierenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDokumentAktivierenFehlerAction(error, x.dokumentAktivierenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumentCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumentCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumentCommandService);
        }
        return this.service;
    }
}
